window.channeldata = [];
window.page = 1;
window.size = 15;
window.gethotest = function (total) {
    size = total;
    getlives();
};
window.getlives = function () {
    showWait();
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/lives/search?page=' + page + '&size=' + 15 + '&type=' + 2,
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    channeldata = result.data;
                    createliveinfo();
                } else {
                    // alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();

            if (channeldata.length == 0) {
                $('.loadmore').hide();
                $('.loadinfo').show();
            } else {
                $('.loadmore').show();
                $('.loadinfo').hide();
                page++;
            }
        }
    });
};

window.createliveinfo = function () {
    for (var i = 0; i < channeldata.length; i++) {
        var info = channeldata[i];

        var date = new Date(info.start_time * 1000);
        var creationTime = dateFormat(date, 'yyyy-MM-dd');
        // var creation_time = getdaysdiff(date);

        var type = info.type;

        var targetHtml = '';
        if (info.state == 3) {
            if (info.type == 1) {
                targetHtml = '<a target="_blank" href="' + ROOT + '/playbacks/' + info.id + '">';
            } else {
                targetHtml = '<a target="_blank" href="' + ROOT + '/playbacks/' + info.id + '">';
            }
        } else {
            targetHtml = '<a target="_blank" href="' + ROOT + '/room/' + info.id + '">';
        }

        var typeText = '';
        if (info.state == 3) {
            typeText = '回放';
        } else if (info.state == 2) {
            typeText = '正在直播';
        } else if (info.state == 1) {
            typeText = '预告';
        }

        var avatar = '';
        if (info.owner_avatar_url && info.owner_avatar_url.length > 0) {
            avatar = '<img src="' + info.owner_avatar_url + '?w=38&h=38&s=3">';
        }

        var html =
            '<div class="liveinfo">' +
            targetHtml +
            '<div class="liveinfo-img">' +
            ((info.cover_url && info.cover_url.length > 0) ?
                '<img src="' + info.cover_url + '?w=210&h=128&s=3">' : '<div class="img-none"></div>') +
            '<div class="liveinfo-type liveinfo-type-' + info.state + '">' +
            '<div class="liveinfo-type-wrap">' +
            '<div class="liveinfo-type-bg"></div>' +
            '<div class="liveinfo-type-text">' + typeText + '</div>' +
            '</div>' +
            '</div>' +
            '<div class="liveinfo-hover"></div>' +
            '</div>' +
            '<div class="liveinfo-title">' +
            '<div class="liveinfo-user-img">' +
            avatar +
            '</div>' +
            '<div class="liveinfo-title-name">' + info.title + '</div>' +
            '</div>' +
            '<div class="liveinfo-user" style="display: none;">' +
            // '<div class="liveinfo-user-islive">' + (info.state == 3 ? '回放' : '正在直播') + '</div>' +
            '<div class="liveinfo-user-name">' + info.owner_nickname + '</div>' +
            '<div class="liveinfo-user-visitcount">' + info.current_visitor_count + '人参与</div>' +
            '</div>' +
            '</a>' +
            '</div>';
        $('.livelist').append(html);
    }
};

$('.loadmore').click(function () {
    gethotest(size);
    // scrollbuttom();
});

window.scrollbuttom = function () {
    $('html').animate({ scrollTop: $('html').height() }, 1000);
};

window.num = 1; // 计数器初始化为1
window.maxnum = 1000; // 设置一共要加载几次
$(window).scroll(function () {
    if ($('.loadmore').length > 0 && $('.curentlives').css('display') == 'block') {
        checkload();
    }
});

window.checkload = function () {

    var srollPos = $(window).scrollTop(); // 滚动条距离顶部的高度

    var windowHeight = $(window).height(); // 窗口的高度

    var dbHiht = $('body').height(); // 整个页面文件的高度

    setTimeout(function () {
        if ((windowHeight + srollPos) >= (dbHiht) && num != maxnum) {
            gethotest(size);
            num++; // 计数器+1
        }

    }, 100);
};